import ClientCaseListRender from 'Components/Client/Cases/CasesTable/ClientCaseListRender';
import { getCasesApi } from 'Constants';
import { Context } from 'Context/Context';
import useIsMobile from 'Hooks/useIsMobile';
import { getCaseType } from 'Utils';
import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import { Link } from 'react-router-dom';

function CompleteClientUserDetails({uploadNew, onClose, userData}) {
    const [caseDets, setCaseDets] = useState(null);
    const isMobile = useIsMobile();
    const [currentTab, setCurrentTab] = useState(0);

    const {makeApiCallFunc} = useContext(Context);

    useEffect(()=>
    {
          makeApiCallFunc(
            getCasesApi+'/'+userData.id,
            null,
            ({data})=>
            {
                setCaseDets(data);
                console.log(data)
            },
            function (error) {
                console.log(error);
            },
            false,
            true
          )
          
    }, []);
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
            zIndex: 30
          
        },
        content: {
            height: 'auto',
            width: isMobile ? '350px':'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
            <div className='w-full font-bold flex items-center justify-center mt-4'>
                
            <div className={'p-2 relative cursor-pointer w-full text-center'+(currentTab === 0 ? " bg-sky-50 border border-sky-600 border-b-0 text-sky-600 " : "  bg-white border-b-sky-600 border")} onClick={() =>setCurrentTab(0)}>Client Details
           
            </div>
            <div className={'p-2 relative cursor-pointer w-full text-center'+(currentTab === 1 ? " bg-sky-50 border border-sky-600 border-b-0 text-sky-600 " : "  bg-white border-b-sky-600 border")} onClick={() =>setCurrentTab(1)}>Case details
            
            </div>
            </div>
        <div className='flex lg:w-[620px] items-center flex-col '>
        {currentTab === 0 ?
        <div className={(currentTab === 0 ? ' bg-sky-50 p-4 border-sky-600 border border-t-0 border-1 ' : '')  + '  flex-col flex w-full'}>
        <div className='flex w-full flex-col justify-between md:flex-row mb-2'>
            <div className='flex w-full justify-left'>
                <div className='mr-5'>
                    <label className="block flex-1 mt-2 mb-1 mb-1 text-sm font-medium leading-6 text-gray-900">
                     Name :
                    </label>
                    {userData?.firstName}{" "}{userData.lastName}
                </div>
            </div>
            <div className=' w-full'>
                <label className="block flex-1 mt-2 mb-1 text-sm font-medium leading-6 text-gray-900">
                Age :
                </label>
                {userData?.age ? userData.age : (
                    <div className='italic'>--</div>
                    )}
            </div>
        </div>
        <div className='flex mb-2'>
            <div className=' md:mr-2 w-full'>
                <label className="block flex-1 mt-2 mb-1 text-sm font-medium leading-6 text-gray-900">
                Email Id :
                </label>
                {userData?.email}
            </div>
            <div className='w-full'>
            <label className="block flex-1 mt-2 mb-1 text-sm font-medium leading-6 text-gray-900">
                Phone Number :
            </label>
            {userData?.phoneNumber ? userData.phoneNumber : (
                    <div className='italic'>--</div>
                    )}
        </div>
        </div>
        
      <div className='flex w-full items-center  flex-col md:flex-row'>
        <div className='w-full'>
            <label className="block flex-1 mt-2 mb-1 text-sm font-medium leading-6 text-gray-900">
          City :
          </label>
          {userData?.city ? userData.city :  (
                    <div className='italic'>--</div>
                    )}
        </div>
        <div className='w-full h-full md:ml-2'>
          <label htmlFor="state" className="block mt-2 text-sm font-medium leading-6 text-gray-900">
          State :
          </label>
          {userData?.state ? userData.state :  (
                    <div className='italic'>--</div>
                    )}

        </div>
      </div>
     
        </div>
        :
        <>
       
        {
            caseDets ? 
        
            <div className={(currentTab === 1 ? '  bg-sky-50 p-4 border-sky-600 border border-t-0 border-1 ' : '')  + ' flex pt-4 w-full'}>
                {caseDets.length ?
                    <div className='flex flex-col w-full text-xs h-[300px] overflow-y-scroll'>
                        <div className='w-full'>
            <div className="w-full  shadow-md rounded my-6 ">
                {/* Table Header */}
                <div className="flex  justify-between items-center bg-gray-200 border-b p-4">
                    <div className="w-1/4">Case Type</div>
                    <div className="w-1/4">Status</div>
                    <div className="w-1/4"> Adverse Party</div>
                    <div className='w-1/4'>Professionals New Requests</div>
                    <div className='w-1/4'>Professionals reviewing</div>
                </div>

                {/* Table Body */}
                <div className="flex flex-col">
                    {caseDets?.map((item, key) => (
                            <Link to={"/client/caseDetails/"+item._id}>
                             <div key={key} className={"flex cursor-pointer justify-between items-center border-b p-4 bg-white " + (item.isClosed?  " text-gray-500" : (item?.isCasePendingClosing ? " text-yellow-500" : (item.review || item.requests ? "text-green-500" : " text-sky-600" )))}>
                                <div className="w-1/4">{getCaseType(item.caseType)}{item?.isCasePendingClosing}</div>
                                
                                <div className="w-1/4">{(item.isClosed?  " Closed" : (item?.isCasePendingClosing ? " Pending close" : " Open" ))}</div>
                                <div className="w-1/4">{item.adversePartyName}</div>
                                <div className="w-1/4">{item.requests ? item.requests : "None"}</div>
                                <div className="w-1/4">{item.review ? item.review : "None"}</div>
                            </div>
                            </Link>
                           
                    ))}
                </div>
                </div>
    </div>
                    </div>
                    :
                   <></>
                }
            
            </div>
            :
            <div>Client has not created any cases so far</div>
        }
         </>
        }
         </div>
    </ReactModal>
  )
}

export default CompleteClientUserDetails;